import {OptionProps} from '@bosch/react-frok';
import {getLocalizedOptionPropName} from '../../../utils';

export const TYPE_ALL = 'all';
export const SELECT_TYPE = 'SELECT_TYPE';

export const getEmptyFileTypeOptionProp = (): OptionProps => {
    return {
        name: getLocalizedBlankFileTypeOptionPropName(),
        value: ''
    }
}

export const getLocalizedFileTypeNameToOptionPropName = (name: string): string => {
    return getLocalizedOptionPropName('FILTER_TYPE_', name);
}

export const getLocalizedBlankFileTypeOptionPropName = (): string => {
    return getLocalizedFileTypeNameToOptionPropName(SELECT_TYPE.toString());
}